import { IconCheck } from '@tabler/icons-react';
import { useFela } from 'react-fela';
import { Controller } from 'react-hook-form';
import { FormattedMessage, useIntl } from 'react-intl';

import { Link, Text } from '@/modules/ui';

import { REVIEW_PLATFORMS } from '../../../../constants';
import { useHandleReviewSiteVisit } from '../../../../hooks';
import type { ReviewPrizepoolFormValues } from '../../../../schemas';
import * as felaRules from './ReviewSites.rules';

export const ReviewSites = () => {
    const { css } = useFela();
    const { formatMessage } = useIntl();

    const handleSiteVisit = useHandleReviewSiteVisit();

    return (
        <ul className={css(felaRules.sitesList)}>
            {REVIEW_PLATFORMS.map(platform => (
                <li key={platform} className={css(felaRules.siteItem)}>
                    <div>
                        <Link
                            color='accentPrimary'
                            size='big'
                            type='native'
                            href={formatMessage({ id: `review-prizepool.form.sites.${platform}.link` })}
                            onClick={() => handleSiteVisit(platform)}
                        >
                            <FormattedMessage id={`review-prizepool.form.sites.${platform}.title`} />
                        </Link>
                        <Text variant='ParagraphSmallMedium' color='foregroundsTertiary'>
                            <FormattedMessage id={`review-prizepool.form.sites.${platform}.description`} />
                        </Text>
                    </div>
                    <Controller<ReviewPrizepoolFormValues>
                        name={`${platform}Visited`}
                        render={({ field: { value: visited } }) => (
                            <div className={css(felaRules.checkCircle)}>
                                {Boolean(visited) && (
                                    <div className={css(felaRules.checkmarkContainer)}>
                                        <IconCheck size={20} color='currentColor' />
                                    </div>
                                )}
                            </div>
                        )}
                    />
                </li>
            ))}
        </ul>
    );
};
